<template>
  <div
    v-if="!loading"
    class="summary-header"
  >
    <div class="row">
      <div class="col-9">
        <!-- First row -->
        <base-cell class="pt-0 pb-0 pl-0" style="min-height: 12px;">
          <base-text
            class="send-type"
            size="s"
            medium
          >
            {{ (item.display == 'html') ? 'SHARE LINK' : item.display.toUpperCase() }}
          </base-text>
        </base-cell>
        <base-cell class="pt-0 pb-0 pl-0 mb-1 mt-1" style="height: 22px;">
          <base-text
            class="subject"
            size="l"
            medium
            trim
          >
            {{ (item.subject) ? item.subject : 'Untitled' | striphtml }}
          </base-text>
        </base-cell>

        <!-- Second row -->
        <base-cell :class="{'pb-0': !isLink && !isEmbedCode}" class="pt-0 pl-0" style="height: 16px;">
          <span class="silka-title" v-html="actionDate" />
        </base-cell>
        <base-cell :class="{'pb-0': !isLink && !isEmbedCode}" class="pt-0 pl-0" style="height: 16px;">
          <div>
            <!-- <base-text
              light
              inline
              class="summary-header__delivered mr-2"
            >
              {{ action }}: <span v-html="actionDate" />
            </base-text> -->

            <template v-if="!isLink && !isEmbedCode">
              <sent-summary-to
                class="summary-header__delivered"
                v-bind="{ item }"
                v-on="$listeners"
              />
            </template>
          </div>
        </base-cell>

        <!-- Third row -->
        <base-cell
          v-if="isLink || isEmbedCode"
          class="pb-0 pl-0"
          style="padding-left: 0px !important;"
          :class="isLink || isEmbedCode ? 'third-row' : '' "
        >
          <sent-summary-to
            class="summary-header__delivered"
            v-bind="{ item }"
            v-on="$listeners"
          />
        </base-cell>
        <base-confirm-dialog
          :show="sendNowConfirmDialog && item.display === SCHEDULED"
          message="Are you sure you want to send?"
          :show-cancel="false"
          positive-text="Send"
          @confirmed="sendNow"
        />
      </div>
      <div class="col-3">
        <!-- First row -->
        <base-cell class="pt-0 pb-0 mb-2">
          <base-button
            v-if="item.can_see_reports && !(item.display === SCHEDULED)"
            class="ml-auto"
            square
            @click="$emit('show-report', item.outreach_pk)"
          >
            View Report
          </base-button>
          <base-button
            v-if="item.display === SCHEDULED"
            class="ml-auto"
            square
            @click="sendNowConfirmDialog = true"
          >
            <base-icon
              icon="mail"
              class="mr-1"
            />
            Send Now
          </base-button>
        </base-cell>
        <base-cell class="pt-0 pb-0 mb-2">
          <base-button
            v-if="item.display === SCHEDULED"
            class="ml-auto"
            square
            @click="cancelSend"
          >
            <base-icon
              icon="x-circle-black"
              class="mr-1"
              style="width: 15px"
            />
            Cancel Send
          </base-button>
          <base-button
            v-else
            class="ml-auto"
            square
            :disable="isCloning"
            @click="$emit('clone')"
          >
            {{ isCloning ? 'Duplicating...' : 'Duplicate' }}
          </base-button>
        </base-cell>
        <base-cell class="pt-0 pb-0 mb-2">
          <!-- Embed button -->
          <template v-if="isEmbedCode">
            <base-button
              v-if="item.can_see_reports"
              class="ml-auto"
              square
              @click="$emit('showLinkModal')"
            >
              <base-icon
                icon="paste-new"
                class="mr-1"
              />
              Embed Code
            </base-button>
          </template>

          <!-- Copy link button -->
          <template v-else-if="isLink">
            <base-button
              v-if="item.can_see_reports"
              class="ml-auto"
              square
              @click="$emit('showLinkModal')"
            >
              <div v-if="isWeChat">
                <base-icon
                  icon="download-new"
                  class="mr-1"
                  style="height: 12px;"
                />
                QR Code
              </div>
              <div v-else>
                <base-icon
                  icon="create-link"
                  class="mr-1"
                  style="height: 12px;"
                />
                Copy Link
              </div>
            </base-button>
          </template>
        </base-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { entryService } from '@/_services';
import emailEngine from '@/components/mixins/emailEngine';
import { EventBus } from '@/event-bus';
import SentSummaryTo from './SentSummaryTo';

const SCHEDULED = 'scheduled';

export default {
  name: 'SentSummaryHeader',
  components: { SentSummaryTo },
  mixins: [emailEngine],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    groups: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    isEmbedCode: {
      type: Boolean,
      default: false,
    },
    isCloning: {
      type: Boolean,
      default: false,
    },
    isWeChat: {
      type: Boolean,
      default: false,
    },
    duplicateLabel: {
      type: String,
      default: 'Duplicate',
    },
    action: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      SCHEDULED,
      sendNowConfirmDialog: false,
    };
  },
  computed: {
    sent() {
      return this.$store.state.entries.emailStatus === 'sent'
       || this.$store.state.entries.gmailStatus === 'sent'
       || this.$store.state.entries.outlookStatus === 'sent';
    },
    actionDate() {
      const date = this.item.display === SCHEDULED ? this.item.scheduled_time : this.item.sent_date;
      return this.fixTimeSpacing(this.$options.filters.nicedate(date, 'long'));
    },
  },
  watch: {
    sent(value) {
      if (value) {
        this.completeSend();
      }
    },
  },
  methods: {
    fixTimeSpacing(value) {
      // This fixes the space between hours and minutes
      return value.replace(':', '<span style="letter-spacing: 1px;">:</span>');
    },
    sendNow() {
      this.sendNowConfirmDialog = false;
      return this.emailEngine.action();
    },
    completeSend() {
      // Resets store.
      this.$store.commit('entries/updateEmailStatus', null, null);
      this.$store.commit('entries/updateOutlookStatus', null, null);
      this.$store.commit('entries/updateGmailStatus', null, null);
      this.$store.commit('entries/updateEmailStatusMessage', null, null);

      this.$nextTick().then(() => {
        this.$router.push('/entries');
      });
    },
    cancelSend() {
      entryService.patchItem({ url: this.edit.url, scheduled_process: null }).then((response) => {
        this.$router.push('/entries').then(() => {
          EventBus.$emit('confirm', {
            title: 'Cancelled',
            message: 'Scheduled send canceled and edit reverted to draft',
            positiveText: 'Accept',
            showCancel: false,
            showCloseButton: true,
          });
        });
      }).catch(() => {
        EventBus.$emit('toast-error', 'Couldn\'t cancel scheduled email, please try again in a few seconds.');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.third-row{
  padding: 0px 11px 0px 11px !important;
  // padding: unset !important;
  margin-top: -27px
}
.silka-title{
  font-family: 'SilkaLight';
  font-size: 14px;
  color: #767676;
}
::v-deep .base-cell{
  border-top: none !important;
}
.subject{
  font-size: 16px;
  color: #1B1B1B;
}
.send-type{
  align-self: flex-start;
  color: #2E7D32;
  font-family: 'SilkaMedium';
  font-size: 12px;
}
::v-deep .base-button{
  font-family: 'SilkaLight';
  background: #FFFFFF;
  height: 36px;
  border: 1px solid #C6C6C6;
  border-radius: 4px;
  min-width: 140px !important;
  font-size: 14px;
  font-style: normal;
  padding: 8.5px 16px;
}
.summary-header{
  background: #FAF9F7;
  border-radius: 4px;
  padding: 24px 24px 32px;

  &__delivered{
      font-size: 14px;
  }
}

.clickable {
  cursor: pointer;
}
</style>
